import { render, staticRenderFns } from "./SaveSampleList.vue?vue&type=template&id=62212173&scoped=true"
import script from "./SaveSampleList.vue?vue&type=script&lang=js"
export * from "./SaveSampleList.vue?vue&type=script&lang=js"
import style0 from "./SaveSampleList.vue?vue&type=style&index=0&id=62212173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62212173",
  null
  
)

export default component.exports